// Global fix for Add to Cart and Buy Now buttons and Mobile Menu
document.addEventListener("DOMContentLoaded", function () {
  console.log("🛒 Initializing global button fixes and mobile menu...");

  function fixAllButtons() {
    // Find all add to cart and buy now buttons
    const buttons = document.querySelectorAll(
      '.btn--add-to-cart, .book-now-button, [name="add"], [type="submit"][value*="cart"], ' +
        'button[onclick*="cart"], .product-form button, .product-single__form button, ' +
        ".savebigontires-cart-btn, .savebigontires-mobile-cart-btn, .cart-toggle",
    );

    buttons.forEach((button, index) => {
      // Skip if already fixed
      if (button.hasAttribute("data-button-fixed")) {
        return;
      }

      // Mark as fixed
      button.setAttribute("data-button-fixed", "true");

      // Ensure button is clickable
      button.disabled = false;
      button.style.pointerEvents = "auto";
      button.style.opacity = "1";

      // Handle cart buttons (header cart)
      if (
        button.classList.contains("cart-toggle") ||
        button.classList.contains("savebigontires-cart-btn") ||
        button.classList.contains("savebigontires-mobile-cart-btn")
      ) {
        // If the ajax cart is available, let theme.js handle showing the drawer/modal
        if (window.ajaxifyShopify || (window.jQuery && jQuery.fn && jQuery.fn.jquery)) {
          return;
        }
        // Fallback: send users to the cart page
        button.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = "/cart";
        });
        return;
      }

      // Handle add to cart buttons
      if (
        button.classList.contains("btn--add-to-cart") ||
        button.name === "add" ||
        button.textContent.toLowerCase().includes("add to cart")
      ) {
        // If this is the header product page button, let its inline onclick submit the product form.
        if (
          button.id === "headerAddToCart" ||
          button.classList.contains("header-add-to-cart-button")
        ) {
          return; // Avoid attaching fallback handlers that conflict with inline submit
        }
        // Find the parent form
        const form = button.closest("form");
        if (form && form.action && form.action.includes("/cart/add")) {
          button.addEventListener("click", function (e) {
            // Let the form submit naturally, but ensure it's set up correctly
            if (!form.method) form.method = "post";
            if (!form.action.includes("/cart/add")) {
              form.action = "/cart/add";
            }
          });
        } else {
          // No form found, create a simple redirect
          button.addEventListener("click", function (e) {
            e.preventDefault();

            // Try to submit any product add-to-cart form on the page first
            const anyForm =
              document.querySelector('form[action*="/cart/add"]') ||
              document.querySelector('[id^="product-form-"]');
            if (anyForm) {
              if (!anyForm.method) anyForm.method = "post";
              if (!anyForm.action || !anyForm.action.includes("/cart/add")) {
                anyForm.action = "/cart/add";
              }
              anyForm.dispatchEvent(
                new Event("submit", { bubbles: true, cancelable: true }),
              );
              return;
            }

            // Fallback: navigate to product page if we truly cannot submit
            const productLink = document.querySelector('a[href*="/products/"]');
            if (productLink) {
              window.location.href = productLink.href;
            } else {
              console.error("Missing product link for button.");
            }
          });
        }
        return;
      }
    });
  }

  // Initial fix
  fixAllButtons();

  // Fix buttons that load later
  setTimeout(fixAllButtons, 2000);

  // Watch for new buttons being added
  const observer = new MutationObserver(() => {
    setTimeout(fixAllButtons, 100);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Mobile menu functionality is now handled by hamburger-click-fix.js
});
